import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

import { t } from '../../locale';

interface UsePaginationStatsArgs {
  currentPage: MaybeRefOrGetter<number>;
  pageSize: MaybeRefOrGetter<number>;
  totalItems: MaybeRefOrGetter<number>;
}

export default function usePaginationStats({ currentPage, pageSize, totalItems }: UsePaginationStatsArgs) {
  return computed(() => {
    const pageSizeVal = toValue(pageSize);
    const currentPageVal = toValue(currentPage);
    const totalItemsVal = toValue(totalItems);

    const from = pageSizeVal * (currentPageVal - 1) + 1;
    const to = Math.min(pageSizeVal * currentPageVal, totalItemsVal);
    const total = totalItemsVal === Infinity ? t('ll.many').toLowerCase() : totalItemsVal;

    return { from, to, total };
  });
}
